import { render, staticRenderFns } from "./code-snippet.vue?vue&type=template&id=e47b90f6&scoped=true&lang=html"
import script from "./code-snippet.vue?vue&type=script&lang=js"
export * from "./code-snippet.vue?vue&type=script&lang=js"
import style0 from "./code-snippet.vue?vue&type=style&index=0&id=e47b90f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b90f6",
  null
  
)

/* custom blocks */
import block0 from "./code-snippet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports